export default "__VITE_ASSET__DSxi6qBX__"